import { useEffect, useRef, useState } from "react";
import { useProducts } from "../contexts/ProductsProvider";
import { useOnScreen } from "./useOnScreen";
import { fetchCollection } from "library/services/fetchers";

function useCollectionScroll({ initialProducts, initialPagination }) {
  const { dispatch: productsDispatch } = useProducts();

  // Infinite scroll
  const triggerRef = useRef(null);
  const isTriggerVisible = useOnScreen(triggerRef, 800);
  const [products, setProducts] = useState(initialProducts);
  const [pagination, setPagination] = useState(initialPagination);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (isTriggerVisible && !isLoading) {
        try {
          console.log("Load next page");
          setIsLoading(true);
          const { handle, locale, endCursor: productCursor } = pagination;

          // const {
          //   products: fetchedProducts,
          //   shopifyProducts: fetchedShopifyProducts,
          //   pagination: fetchedPagination,
          // } = await fetchCollection({ handle, locale, productCursor });

          const {
            products: fetchedProducts,
            shopifyProducts: fetchedShopifyProducts,
            pagination: fetchedPagination,
          } = await fetchCollection({ handle, locale, productCursor });

          // update sanity products
          setProducts([...products, ...fetchedProducts]);

          // update shopify products
          productsDispatch({
            type: "ADD",
            shopifyProducts: fetchedShopifyProducts,
          });

          setPagination(fetchedPagination);
        } catch (e: any) {
          console.log("Console scroll load failed");
        }

        setIsLoading(false);
      }
    };

    if (pagination.hasNextPage) run();
  }, [isLoading, isTriggerVisible]);

  return {
    products,
    triggerRef,
  };
}

export default useCollectionScroll;
